import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import type { TFunction } from 'i18next';
import { getStringFilterOperators } from '@/lib/stringGridFilters';

/**
 * The Roles grid's columns. Every filterable column has a matching value/operator pair on the
 * server (GetRoleListInput) and every sortable one is on its sort whitelist.
 */
export function buildRoleListColumns(t: TFunction): GridColDef[] {
  return [
    {
      field: 'name',
      headerName: t('identity.roleName'),
      width: 240,
      filterOperators: getStringFilterOperators(),
    },
    {
      field: 'isDefault',
      headerName: t('identity.isDefaultShort'),
      type: 'boolean',
      width: 110,
      renderCell: (params) =>
        params.value ? <Chip label={t('identity.isDefaultShort')} size="small" color="info" /> : null,
    },
    {
      field: 'isStatic',
      headerName: t('identity.isStatic'),
      type: 'boolean',
      width: 110,
      renderCell: (params) =>
        params.value ? <Chip label={t('identity.isStatic')} size="small" color="warning" variant="outlined" /> : null,
    },
    {
      field: 'isPublic',
      headerName: t('identity.isPublic'),
      type: 'boolean',
      width: 110,
      renderCell: (params) =>
        params.value ? <Chip label={t('identity.isPublic')} size="small" color="success" variant="outlined" /> : null,
    },
  ];
}
